module.exports = __webpack_public_path__ + "img/honduras.fd1ddd1.webp";